import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { Size } from '../interfaces/size';

@Injectable({ providedIn: 'root' })
export class ScreenSizeService {
  private _size = new BehaviorSubject<Size>('large');

  get size() {
    return this._size.pipe(distinctUntilChanged());
  }

  setSize(size: Size) {
    this._size.next(size);
  }
}
